import React from 'react';
import { useAuth } from '../../contexts/Auth/authContext';
import { useClientAccess } from '../../hooks/useClientAccess';
import { useI18n } from '../../contexts/I18nContext';
import config from '../../config/env';
import { environmentFromOAuthClientId } from '../../utils/clientGroups';

export const NoClientAccessBanner: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const { hasAnyClientAccess, isSuperAdmin, hasApplicationRole } = useClientAccess();
  const { t } = useI18n();
  if (loading || !isAuthenticated || isSuperAdmin || hasAnyClientAccess) {
    return null;
  }
  if (!hasApplicationRole) {
    return null;
  }
  const env = environmentFromOAuthClientId(config.oauth.clientId);
  return (
    <div className="no-client-access-banner" role="status" data-testid="no-client-access-banner">
      <span className="no-client-access-icon" aria-hidden="true">⚠</span>
      <div className="no-client-access-body">
        <strong>{t('errors.noClientAccessTitle')}</strong>
        <p>{t('errors.noClientAccessBody', { env })}</p>
      </div>
    </div>
  );
};
